export default __webpack_public_path__ + "static/media/logo_pnsv_horizontal_color.c4652a89.png";